import { CSSProperties, FC, useMemo } from 'react'
import Link from 'next/link'
import { City } from 'graphql/types'
import { orderCitiesByVolume } from 'lib/cities'
import { getRegionImageUrl } from 'lib/region'
import * as events from 'pages/regioes-atendidas/events'
import Typography from 'components/Typography'
import styles from './Cities.module.scss'

type TProps = {
  cities?: Array<City>
}

const Cities: FC<TProps> = ({ cities }) => {
  const orderedCities = useMemo(() => orderCitiesByVolume(cities), [cities])

  return (
    <div className={styles.ecRegionsServedCitiesContainer}>
      {orderedCities.map(
        ({ name, nameSlug, state, stateSlug, imageFilename }) => {
          const city = name as string
          const citySlug = nameSlug as string
          const href = `/regioes-atendidas/${stateSlug as string}/${citySlug}`
          const label = `${city}, ${state as string}`

          return (
            <Link
              key={`${citySlug}-${stateSlug as string}`}
              passHref
              href={href}
              className={styles.ecRegionsServedCitiesItem}
              onClick={() =>
                events.cityCardClickEvent({
                  url: href,
                  label,
                  city,
                  state: state as string,
                })
              }
              style={
                {
                  '--backgroundUrl': `url(${getRegionImageUrl(imageFilename)})`,
                } as CSSProperties
              }
            >
              <Typography variant="Title" bold>
                {label}
              </Typography>
            </Link>
          )
        },
      )}
    </div>
  )
}

export default Cities
